export const hoursToISO8601Duration = (hours: number): string => {
  if (!hours || isNaN(hours)) return 'PT0H';
  return `PT${Math.round(hours)}H`;
};

export const getHoursDuration = (course: any): number => {
  const duration = course?.content_duration + course?.practice_duration;
  if (!duration || isNaN(duration)) return 0;
  return duration;
};

export const getIndexedPlans = (plans: any) =>
  plans.reduce((acc: any, plan: any) => {
    if (plan?.items && Object.keys(plan?.items).length) {
      const currentPlanItems = Object.values(plan?.items).map((item: any) => ({
        ...item,
      }));
      return {
        ...acc,
        ...getIndexedPlans(currentPlanItems),
      };
    }
    return {
      ...acc,
      [plan.name]: {
        ...plan,
      },
    };
  }, {})